import React from "react";
import { EnterpriseUserInfoViewModel, IEnterpriseUserInfoViewModel, IUserInfoViewModel, UserInfoViewModel } from "Services/API/API";

export interface IEnterpriseAccountPortalUser {
   user: IUserInfoViewModel,
   enterpriseUser: IEnterpriseUserInfoViewModel
}

interface IEnterpriseUserContext extends IEnterpriseAccountPortalUser {
   refresh(): Promise<IEnterpriseAccountPortalUser>
}

const UserContext = React.createContext<IEnterpriseUserContext>({
   user: new UserInfoViewModel(),
   enterpriseUser: new EnterpriseUserInfoViewModel(),
   refresh() {
      return Promise.resolve({
         user: new UserInfoViewModel(),
         enterpriseUser: new EnterpriseUserInfoViewModel()
      });
   }
});

export default UserContext;